module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/hero_mob-a5cfc5ea7302d5a825f032f3284e1cbb.jpg";